<label [class]="'form-label text-start w-100 ' +  class()" [attr.for]="controlId() || null">
    {{ labelText() }}
    @if (isRequired()) {
        <fa-duotone-icon icon="dot" size="xl" secondaryOpacity="0.9" class="text-danger px-1"/>
    }
    @if (tooltip(); as tooltipText) {
        <fa-duotone-icon icon="circle-info" secondaryOpacity="0.2" class="text-primary ms-1" transform="grow-4"
            [msTooltip]="tooltipText" />
    }
</label>
